import { useMemo, type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { Surface, Text } from 'react-native-paper';

import { LocalizationNameSpace } from '@/localization/types/localizationTypes';
import { useAppTheme } from '@/styles/hooks/useAppTheme';
import type { AppTheme } from '@/styles/theme';

const makeStyles = (theme: AppTheme) =>
  StyleSheet.create({
    container: {
      backgroundColor: theme.colors.tertiaryContainer,
      borderRadius: 20,
      marginHorizontal: 16,
      marginVertical: 8,
      overflow: 'hidden'
    },
    contentWrapper: { paddingHorizontal: 16, paddingVertical: 8 },
    deleted: { fontStyle: 'italic' }
  });

export const DeletedRefChatMessage: FC = () => {
  const theme = useAppTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);
  const { t } = useTranslation(LocalizationNameSpace.CHATS, {
    keyPrefix: 'screens.chat.message'
  });

  return (
    <Surface
      style={[
        styles.container,
        {
          backgroundColor: theme.colors.surfaceContainerLow
        }
      ]}
      elevation={0}
    >
      <View style={styles.contentWrapper}>
        <Text variant="bodyLarge" style={styles.deleted}>
          {t('deleted')}
        </Text>
      </View>
    </Surface>
  );
};
